import { render, staticRenderFns } from "./datachart.vue?vue&type=template&id=a6f68bbe&scoped=true&"
import script from "./datachart.vue?vue&type=script&lang=js&"
export * from "./datachart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f68bbe",
  null
  
)

export default component.exports